import { FieldType } from "../../type-system/FieldType";
import { ShopifyAppPurchaseOneTimeKey, ShopifyAppPurchaseOneTimeToShopKey, ShopifyShopKey } from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyAppPurchaseOneTimeKey,
  "2022-01": {
    name: "Shopify App Purchase One Time",
    graphQLTypename: "AppPurchaseOneTime",
    fields: [
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "createdAt" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "id" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "name" } },
      },
      {
        name: "Price",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "price", graphQLSelection: `amount currencyCode` } },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "status", isShopifyEnum: true } },
        configuration: {
          allowMultiple: false,
          allowOther: true,
          options: [{ name: "PENDING" }, { name: "ACTIVE" }, { name: "DECLINED" }, { name: "EXPIRED" }, { name: "ACCEPTED" }],
        },
      },
      {
        name: "Test",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "test" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyAppPurchaseOneTimeToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_node_list",
      resource: "appPurchaseOneTime",
    },
  },
  "2025-04": {
    syncConfig: {
      type: "graphql_list",
      resource: "oneTimePurchases",
      filters: {},
    },
  },
};

export const ShopifyAppPurchaseOneTime = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
